var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        { attrs: { titulo: "Editar Ruta" }, on: { cerrar: _vm.handleCerrar } },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos },
            on: { guardar: _vm.handleGuardar },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.informacionGeneral } },
                [
                  _c("CrearRutaForm", {
                    attrs: {
                      rutaSeleccionada: _vm.rutaSeleccionada,
                      modoEditar: true
                    },
                    on: {
                      change: _vm.handleFormChange,
                      estadoSwitch: _vm.handleSwitch,
                      nombre: _vm.handlenombre,
                      changeDatosZonas: _vm.handleDatosZonas
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarEventos } },
                [
                  _c("AsociarEventosFormEdit", {
                    attrs: {
                      idRuta: _vm.idRuta,
                      lstRutas: _vm.lstRutas,
                      lstselectedTipoEvento: _vm.lstselectedTipoEvento,
                      lsSelectedMsj: _vm.lsSelectedMsj,
                      rutaSeleccionada: _vm.rutaSeleccionada
                    },
                    on: {
                      change: _vm.handleFormChangeAsociar,
                      estadoSwitch: _vm.handleSwitch,
                      handleZonaEventos: _vm.handleZonaEventos
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarMensajes } },
                [
                  _c("AsociarMensajesFormEdit", {
                    attrs: {
                      lstselectedTipoEvento: _vm.grillaEventoMensajes,
                      mensajes: _vm.mensajeSeleccionados,
                      lsSelectedMsj: _vm.lsSelectedMsj,
                      idRuta: _vm.idRuta,
                      demoM: _vm.demo
                    }
                  })
                ],
                1
              ),
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.asociarVehiculos } },
                [
                  _c("AsociarFlotaEtiquetaVehiculoIndividual", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.pasoActivoIndex ===
                          _vm.pasos.asociarVehiculos.step,
                        expression:
                          "pasoActivoIndex === pasos.asociarVehiculos.step"
                      }
                    ],
                    attrs: {
                      "col-def-vehiculo": _vm.vehiculoColDefs,
                      vehiculosIdSeleccionar: _vm.vehiculosIdSeleccionar,
                      flotasIdSeleccionar: _vm.flotasIdSeleccionar,
                      etiquetasIdSeleccionar: _vm.etiquetasIdSeleccionar,
                      esEditar: true
                    },
                    on: { change: _vm.handleAsociacionesChange }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacionGuardar,
          titulo: _vm.$t("mensajes.crud.editar.titulo", { entidad: "Ruta" }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      }),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion,
          items: _vm.itemsNoValidos
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "380" },
          model: {
            value: _vm.showValidacionLineal,
            callback: function($$v) {
              _vm.showValidacionLineal = $$v
            },
            expression: "showValidacionLineal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v(_vm._s(_vm.tituloValidacion))]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", [
                _c("span", [_vm._v("Debe ingresar:")]),
                _c("br"),
                _c("br"),
                _c(
                  "ul",
                  _vm._l(_vm.camposZonaEmpty, function(ce) {
                    return _c("li", { key: ce }, [_vm._v(_vm._s(ce))])
                  }),
                  0
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.showValidacionLineal = false
                        }
                      }
                    },
                    [_vm._v("Aceptar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }